import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import { withStyles } from "@material-ui/core/styles"
import KeymanProfile from "./keyman-profile"
import CorporationProfile from "./corporation-profile"
import RankingProfile from "./ranking-profile"

const styles = theme => ({
  section: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px #254E781A",
    position: "relative",
  },

  loaderContainer: {
    minHeight: "400px",
    position: "relative",
  },

  gutters: {
    width: "100%",
    background: "#040E35",
    color: "#FFFFFF",
    fontSize: "13px",
    fontWeight: "bold",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "8px 8px 0px 0px",
    padding: "10px 12px",
    boxSizing: "border-box",
    height: "37px",
  },
})

const KeymanDetail = ({
  classes,
  item,
  departmentRankStats,
  getRankDepartmentsById,
  jsicSRankStats,
  getRankJsicSById,
  executiveCorporationTotal,
  executiveTotal,
}) => {
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">
          {`{
            "@context": "http://schema.org/",
            "@type": "Person",
            "name": "${item.name}",
            "jobTitle": "${item.honorific}",
            "telephone": "${item.shikiho_tel}",
            "url": "https://keyman-db.smart-letter.com/keymans/${item.id}"
          }`}
        </script>
      </Helmet>
      <div className={classes.section}>
        <KeymanProfile
          item={item}
          departmentRankStats={departmentRankStats}
          getRankDepartmentsById={getRankDepartmentsById}
          executiveCorporationTotal={executiveCorporationTotal}
          executiveTotal={executiveTotal}
        />
      </div>

      <div className={classes.section} style={{ marginTop: "40px" }}>
        <CorporationProfile
          item={item}
          jsicSRankStats={jsicSRankStats}
          getRankJsicSById={getRankJsicSById}
        />
      </div>

      <div className={classes.section} style={{ marginTop: "40px" }}>
        <RankingProfile
          item={item}
          departmentRankStats={departmentRankStats}
          getRankDepartmentsById={getRankDepartmentsById}
          jsicSRankStats={jsicSRankStats}
          getRankJsicSById={getRankJsicSById}
        />
      </div>
    </div>
  )
}

KeymanDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

export default withStyles(styles)(KeymanDetail)
